import { render, staticRenderFns } from "./referDialog.vue?vue&type=template&id=7ffb2af0&scoped=true&"
import script from "./referDialog.vue?vue&type=script&lang=js&"
export * from "./referDialog.vue?vue&type=script&lang=js&"
import style0 from "./referDialog.vue?vue&type=style&index=0&id=7ffb2af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffb2af0",
  null
  
)

export default component.exports